"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactive_vue_1 = require("@formily/reactive-vue");
var vue_1 = require("@formily/vue");
var vue_demi_1 = require("vue-demi");
// @ts-ignore
var CountDownTimeButton_vue_1 = __importDefault(require("./CountDownTimeButton.vue"));
var formilyCountDownTimeButton = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'countDownTimeButton',
    props: ['value'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        var field = (0, vue_1.useField)();
        var data = field.value.componentProps;
        console.log('formilyCountDownTimeButton==>', data);
        return function () { return (0, vue_1.h)(CountDownTimeButton_vue_1.default, {
            attrs: __assign(__assign(__assign({}, curProps), attrs), { value: curProps.value, type: data.type || 'primary', size: data.size || 'normal', stayTime: data.stayTime || 5, beforeClickText: data.beforeClickText || '阅读前按钮文案', afterClickText: data.afterClickText || '阅读后按钮文案', linkUrl: data.linkUrl || '' }),
            on: {
                'input': function (value) {
                    emit('input', value);
                },
                'change': function (value) {
                    emit('change', value);
                },
            },
        }, {
            default: function () { return [curProps.value || attrs.content]; },
        }); };
    },
}));
exports.default = formilyCountDownTimeButton;
